import React from 'react'
import commonbanner from '../../../assets/common-banner.png'
import {Link} from 'react-router-dom'
import { ID, IE } from 'country-flag-icons/react/3x2';

const Webtoggle = () => {
  return (
    <div className="grid grid-cols-2 gap-10 mx-20 pb-10 my-20 w-full px-40">
      <div className="flex flex-col mb-10">
        <img src={commonbanner} alt='' className='shadow-md p-0 rounded-xl w-[400px] h-[380px]' />
        <div className="font-prime font-semibold text-2xl mt-5 text-wrap w-[400px]">Voice Chat Web App For Scalable Decision Making</div>
        <div className="flex flex-row my-8 gap-10">
          <div className="font-prime font-bold border p-3 rounded-3xl flex flex-row w-auto items-center bg-gray-100">
              <IE title="Ireland" style={{width: '30px', height: '30px', marginRight: '10px'}}/>Ireland
          </div>
          <div className="font-prime font-bold border p-3 rounded-3xl w-20 flex items-center justify-center bg-gray-100">
            web
          </div>
        </div>
        <div className="font-prime font-normal text-2xl text-gray-500 pr-40">Learn how in 14 weeks, we built and launched a highly scalable and engaging web-based audio platform that enables scalable decision-making for civic participation, corporations, and institutions.</div>
        <Link to='/work/voice-app' className="text-prime flex text-xl font-bold font-[Montserrat] mt-5">
          See Our Approach <ion-icon name="arrow-forward-outline"></ion-icon>
        </Link> 
      </div>
      <div className="flex flex-col mb-10">
        <img src={commonbanner} alt='' className='shadow-md p-0 rounded-xl w-[400px] h-[380px]' />
        <div className="font-prime font-semibold text-2xl mt-5 text-wrap w-[400px]">Centralised App For Food Order Management</div>
        <div className="flex flex-row my-8 gap-10">
          <div className="font-prime font-bold border p-3 rounded-3xl flex flex-row w-auto items-center bg-gray-100">
              <ID title="Indonesia" style={{width: '30px', height: '30px', marginRight: '10px'}}/>Indonesia
          </div>
          <div className="font-prime font-bold border p-3 rounded-3xl w-20 flex items-center justify-center bg-gray-100">
            web
          </div>
        </div>
        <div className="font-prime font-normal text-2xl text-gray-500 pr-40">Gula streamlines food order management in Indonesia by consolidating orders from multiple delivery partners for restaurants to increase sales, manage operations, and update menus in one place.</div>
        <Link to='/work/food-app' className="text-prime flex text-xl font-bold font-[Montserrat] mt-5">
          See Our Approach <ion-icon name="arrow-forward-outline"></ion-icon>
        </Link> 
      </div>
     </div>
  )
}

export default Webtoggle